import { Construction } from 'lucide-react';

/**
 * Henüz implemente edilmemiş sayfalar için ortak placeholder.
 * Faz 4-5'te yerini gerçek sayfa içeriklerine bırakır.
 */
export default function ComingSoon({ title, hint }: { title: string; hint?: string }) {
  return (
    <div className="h-full flex flex-col items-center justify-center text-center px-6 gap-4">
      <div className="w-16 h-16 rounded-2xl bg-brand-50 text-brand-600 flex items-center justify-center">
        <Construction size={28} />
      </div>
      <div>
        <h1 className="text-xl font-semibold text-slate-900 tracking-tight">{title}</h1>
        {hint && <p className="text-sm text-slate-500 mt-1.5 max-w-md">{hint}</p>}
        <p className="text-xs text-slate-400 mt-3">Bu sayfa yakında eklenecek.</p>
      </div>
    </div>
  );
}
